import { useMediaQuery } from "@mui/material";

/**
 * Custom hook to detect desktop breakpoint
 *
 * Provides a simple, reusable way to check if the viewport is at desktop
 * size or larger. Uses MUI's useMediaQuery for consistent behavior across
 * the application.
 *
 * @param breakpoint - Minimum width in pixels to consider desktop (default: 992)
 * @returns true if viewport is at or above the breakpoint, false otherwise
 *
 * @example
 * const isDesktop = useDesktopBreakpoint(); // Uses default 992px
 * const isLargeDesktop = useDesktopBreakpoint(1200); // Custom breakpoint
 */
const useDesktopBreakpoint = (breakpoint: number = 992): boolean => useMediaQuery(`(min-width: ${breakpoint}px)`, {
    defaultMatches: true // SSR-safe: assume desktop by default for hydration consistency
  });

export default useDesktopBreakpoint;